export { SysqueDropdownServiceTypeModule } from './sysque-dropdown-service-type.module';
export { SysqueDropdownServiceTypeComponent } from './sysque-dropdown-service-type.component';